export const baseChars = [
  { char: "ᯀ", latin: "a" },
  { char: "ᯂ", latin: "ha" },
  { char: "ᯄ᯦", latin: "ka" },
  { char: "ᯅ", latin: "ba" },
  { char: "ᯇ", latin: "pa" },
  { char: "ᯉ", latin: "na" },
  { char: "ᯋ", latin: "wa" },
  { char: "ᯍ", latin: "wa" },
  { char: "ᯎ", latin: "ga" },
  { char: "ᯐ", latin: "ja" },
  { char: "ᯑ", latin: "da" },
  { char: "ᯒ", latin: "ra" },
  { char: "ᯔ", latin: "ma" },
  { char: "ᯗ", latin: "ta" },
  { char: "ᯖ", latin: "ta" },
  { char: "ᯘ", latin: "sa" },
  { char: "ᯛ", latin: "ya" },
  { char: "ᯝ", latin: "nga" },
  { char: "ᯞ", latin: "la" },
  { char: "ᯠ", latin: "nya" },
  { char: "ᯤ", latin: "i" },
  { char: "ᯥ", latin: "u" },
];

export const diacritics = [
  { mark: "ᯪ", latin: "i", name: "uluwa" },
  { mark: "ᯮ", latin: "u", name: "boruta" },
  { mark: "ᯩ", latin: "é", name: "hatadingan" },
  { mark: "ᯬ", latin: "o", name: "siala" },
];

export const hamisaran = { mark: "ᯰ", latin: "ng" };

export const pangolat = { mark: "᯲", latin: "" };

// Group baseChars by latin
export const groupedBaseChars = Object.values(
  baseChars.reduce((acc, curr) => {
    if (!acc[curr.latin]) acc[curr.latin] = { chars: [], latin: curr.latin };
    acc[curr.latin].chars.push(curr.char);
    return acc;
  }, {} as Record<string, { chars: string[]; latin: string }>)
);
